import type { InjectionKey } from "vue";
import type { AppConfig } from "../app_config_provider";

const API_PATH = "/v4/netz";

export interface NetzDto {
  id: number;
  slug: string;
  vat_type: string;
  business_type: string;
}

export class NetzApi {
  private readonly config: Pick<AppConfig, "api_url" | "api_token">;

  constructor(config: Pick<AppConfig, "api_url" | "api_token">) {
    this.config = config;
  }

  async getById(
    netzId: number,
  ): Promise<NetzDto | null> {
    const response = await fetch(`${this.config.api_url}${API_PATH}/${netzId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-API-TOKEN": this.config.api_token,
      },
    });

    if (!response.ok) {
      console.log(`netzById: ${response.status} ${response.statusText}`);
      throw new Error('General_Api_Failed')
    }

    return response.json() as Promise<NetzDto|null>;
  }
}

export const netzApiKey: InjectionKey<NetzApi> = Symbol("netz-api");
